var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPriceTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.047)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.379,22a1.921,1.921,0,0,1-1.368-.566L.565,14.989a1.936,1.936,0,0,1,0-2.734L12.606.189A.649.649,0,0,1,13.062,0H18.09a.637.637,0,0,1,.455.189l3.266,3.265A.644.644,0,0,1,22,3.91V8.895a.64.64,0,0,1-.188.455L9.746,21.434A1.921,1.921,0,0,1,8.379,22ZM6.786,10.787a.673.673,0,0,0-.477.2,2,2,0,0,0,0,2.846l-.611.609a.668.668,0,0,0,0,.949.676.676,0,0,0,.953,0l.612-.609a2.029,2.029,0,0,0,2.861,0l.266-.265a2,2,0,0,0,.379-2.323L9.732,10.126a.668.668,0,0,1,.126-.774l.266-.265a.679.679,0,0,1,.954,0l.954.949a.669.669,0,0,1,0,.949.671.671,0,0,0,.477,1.145.673.673,0,0,0,.477-.2,2,2,0,0,0-.008-2.853l.586-.613a.667.667,0,0,0-.023-.948.676.676,0,0,0-.953.023l-.563.589a2.03,2.03,0,0,0-2.853.007L8.9,8.4a2,2,0,0,0-.379,2.323l1.038,2.065a.667.667,0,0,1-.127.774l-.266.265a.677.677,0,0,1-.954,0l-.954-.949a.668.668,0,0,1,0-.949.668.668,0,0,0,0-.949A.673.673,0,0,0,6.786,10.787ZM16.5,3.667A1.833,1.833,0,1,0,18.333,5.5,1.835,1.835,0,0,0,16.5,3.667Z",
    transform: "translate(-0.047)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPriceTag);
export default __webpack_public_path__ + "static/media/icon-price-tag.0473be1c7f9f75448c3c01f7a5636c1c.svg";
export { ForwardRef as ReactComponent };